import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { PAYMENT_STATUS_META, REJECTION_REASONS } from "@/lib/tournament";

export default function RosterConfirm({ action, onCancel, onConfirm }) {
  const [reason, setReason] = useState("");
  useEffect(() => { setReason(""); }, [action]);
  if (!action) return null;
  const isDelete = action.type === "delete";
  const rejecting = action.status === "rejected";
  const label = isDelete ? "" : (PAYMENT_STATUS_META[action.status] || { l: action.status }).l;
  return (
    <Dialog open onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="glass max-w-lg" style={{ background: "var(--surface-glass)" }} data-testid="roster-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{action.type === "partner" ? "Accept the partner invite?" : isDelete ? "Delete this registration?" : rejecting ? "Reject this registration?" : `Change status to ${label}?`}</DialogTitle>
          <DialogDescription style={{ color: "var(--text-2)" }}>
            {action.type === "partner" ? `You'll accept ${action.partner}'s invite to partner ${action.name} on their behalf. ${action.partner} will be emailed.`
              : isDelete ? `${action.name} will be permanently removed from the roster. This cannot be undone.`
              : rejecting ? `${action.name} will be emailed that their registration was not accepted, with the reason below. Their spot is freed for the waitlist.`
              : `${action.name}'s registration will be marked ${label}.`}
          </DialogDescription>
        </DialogHeader>
        {rejecting && (
          <div className="space-y-3">
            <div className="flex flex-wrap gap-1.5" data-testid="reject-suggestions">
              {REJECTION_REASONS.map((r, i) => (
                <button key={r} type="button" data-testid={`reject-reason-${i}`} onClick={() => setReason(r)}
                  className="text-left text-xs rounded-full px-3 py-1.5 transition-colors"
                  style={reason === r ? { background: "var(--primary)", color: "var(--on-primary)" } : { background: "var(--bg)", color: "var(--text)", border: "1px solid var(--border)" }}>{r}</button>
              ))}
            </div>
            <textarea data-testid="reject-reason-input" rows={3} value={reason} onChange={(e) => setReason(e.target.value.slice(0, 500))}
              placeholder="Reason for rejection (included in the email)" className="w-full rounded-xl bg-surface glow-border px-3 py-2.5 text-sm outline-none" style={{ color: "var(--text)" }} />
          </div>
        )}
        <DialogFooter>
          <button data-testid="roster-confirm-cancel" onClick={onCancel} className="glass rounded-full px-5 py-2.5 text-sm font-bold" style={{ color: "var(--text)" }}>Cancel</button>
          <button data-testid="roster-confirm-yes" disabled={rejecting && !reason.trim()} onClick={() => onConfirm(reason.trim())}
            className="rounded-full px-5 py-2.5 text-sm font-bold disabled:opacity-40"
            style={isDelete || rejecting ? { background: "#ef4444", color: "#fff" } : { background: "var(--primary)", color: "var(--on-primary)" }}>
            {action.type === "partner" ? "Yes, accept partner" : isDelete ? "Yes, delete" : rejecting ? "Yes, reject & email" : "Yes, update"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
